import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import useAdminItemStore from '../../stores/admin/itemStore'
import useToastStore from '../../stores/toastStore'

const ChangeImageModal = ({ show, onHide, item, onUpdate }) => {
    const [selectedImage, setSelectedImage] = useState(null)
    const [imageBase64, setImageBase64] = useState('')
    const { updateItem } = useAdminItemStore()
    const { addToast } = useToastStore()

    const handleImageUpload = (event) => {
        const file = event.target.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onloadend = () => {
                setImageBase64(reader.result)
            }
            reader.readAsDataURL(file)
            setSelectedImage(file)
        }
    }

    const handleSubmit = async () => {
        if (!selectedImage || !item.id) return

        const formData = new FormData()
        formData.append('image', selectedImage)

        const response = await updateItem(item.id, { image: imageBase64 })

        if (response.success) {
            addToast('Image updated successfully!', 'success')
            if (onUpdate) {
                onUpdate(response.data)
            }
            onHide()
        } else {
            addToast('Failed to update image', 'error')
        }
    }

    const handleHide = () => {
        setSelectedImage(null)
        setImageBase64('')
        onHide()
    }

    return (
        <Modal show={show && item} onHide={handleHide}>
            <div className="modal-body space-y-20 pd-40">
                <h3 className="text-center">Update Item Image</h3>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    className="form-control item-image-uploader"
                />
                {selectedImage && (
                    <div className="text-center mt-3">
                        <h5>New Image:</h5>
                        <img
                            src={URL.createObjectURL(selectedImage)}
                            alt="Selected"
                            style={{ width: '100%', height: 'auto', marginTop: '10px' }}
                        />
                    </div>
                )}
                {item?.images?.[0] && !selectedImage && (
                    <div className="text-center mt-3">
                        <h5>Current Image:</h5>
                        <img
                            src={item.images[0].url}
                            alt="Current"
                            style={{ width: '100%', height: 'auto', marginTop: '10px' }}
                        />
                    </div>
                )}
                <div className="text-center mt-3">
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={!selectedImage}>
                        Update
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default ChangeImageModal
